import axios from "axios";
import { decode } from "./userApi";

export const upgradeMultitap = async (token) => {
  try {
    const response = await axios.post(
      `https://api.hare-online.com/boosts/multi-tap/${decode(token)}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (err) {
    console.error("Ошибка при повышении уровня мультитап", err);
    return null;
  }
};

export const upgradeEnergy = async (token) => {
  try {
    const response = await axios.post(
      `https://api.hare-online.com/boosts/energy/${decode(token)}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (err) {
    console.error("Ошибка при повышении уровня энергии", err);
    return null;
  }
};

export const upgradeMining = async (token) => {
  try {
    const response = await axios.post(
      `https://api.hare-online.com/mining/upgrade_mining/${decode(token)}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (err) {
    console.error("Ошибка при повышении уровня майнинга", err);
    return null;
  }
};

export const claim = async (token) => {
  try {
    const response = await axios.post(
      `https://api.hare-online.com/mining/claim/${decode(token)}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (err) {
    console.error("Ошибка при повышении уровня майнинга", err);
    return null;
  }
};
